import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { APP_LANG_STORAGE_KEY, APP_LANGS } from './app.config';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  readonly #translateService = inject(TranslateService);

  constructor() {
    this.#translateService.addLangs(Object.values(APP_LANGS));
    this.#translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe(({ lang }) => localStorage.setItem(APP_LANG_STORAGE_KEY, lang));
  }
}
